// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2zhep","title":"InfoRow_title__5YkVl"};